var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0" } },
    [
      _vm.model == null
        ? _c(
            "v-card",
            { attrs: { height: "20px", elevation: "0" } },
            [
              _c("v-progress-linear", {
                attrs: {
                  color: "red accent-4",
                  indeterminate: "",
                  rounded: "",
                  height: "6",
                },
              }),
            ],
            1
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { outlined: "", width: "100%" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "ma-0 pa-2" },
                        [
                          _c("v-card-text", {
                            staticClass: "ma-2 pa-0 grey--text",
                          }),
                          _c("v-spacer"),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "white--text",
                                              attrs: {
                                                elevation: "0",
                                                color: "green",
                                              },
                                              on: {
                                                click: _vm.onPressImportJson,
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(" Import REWARDS Json "),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { size: "22" },
                                            },
                                            [
                                              _vm._v(
                                                "mdi-database-import-outline"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_c("span", [_vm._v("Import Json")])]
                          ),
                          _c("input", {
                            ref: "uploaderJson",
                            staticClass: "d-none",
                            attrs: { type: "file", accept: "application/JSON" },
                            on: { change: _vm.onFileChangedJson },
                          }),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "white--text ml-2",
                                              attrs: {
                                                elevation: "0",
                                                color: "red",
                                              },
                                              on: {
                                                click: _vm.onPressImportFile,
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(" add file "),
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-plus")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_c("span", [_vm._v("Add file")])]
                          ),
                          _c("input", {
                            ref: "uploaderFile",
                            staticClass: "d-none",
                            attrs: { type: "file" },
                            on: { change: _vm.onFileChangedFile },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0 mt-3" },
                [
                  _vm.working
                    ? _c("v-progress-linear", {
                        attrs: {
                          color: "red accent-4",
                          indeterminate: "",
                          rounded: "",
                          height: "6",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0 mt-3" },
                [
                  _c(
                    "v-card",
                    { attrs: { outlined: "", elevation: "0", width: "100%" } },
                    [
                      _c("v-data-table", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "fixed-header": "",
                          items: _vm.files,
                          headers: _vm.headers,
                          "hide-default-header": "",
                          "hide-default-footer": "",
                          "disable-pagination": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.size",
                            fn: function ({ item }) {
                              return [
                                _c("v-card-text", [
                                  _vm._v(_vm._s(_vm.getSize(item.size))),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "item.actions",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass: "mr-0",
                                                      attrs: {
                                                        icon: "",
                                                        color: "green",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onPressPreview(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { size: "22" } },
                                                    [_vm._v("mdi-eye")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v("Preview File")])]
                                ),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass: "mr-0",
                                                      attrs: {
                                                        icon: "",
                                                        color: "red",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onPressDelete(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { size: "22" } },
                                                    [_vm._v("mdi-delete")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v("Delete File")])]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }